const getQueryParameter = (value, uri) => {
  const url = uri || window.location.href
  const name = value.replace(/[[\]]/g, '\\$&')
  const pattern = `[?&]${name}(=([^&#]*)|&|#|$)`
  const regex = new RegExp(pattern)
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export default getQueryParameter
